import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faExpand,
  faImages,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import './Gallery.css';

const ITEMS_PER_PAGE = 12;

const galleryImages = [
  { src: '/external/images/gallery/img1.jpeg', alt: 'Students together on campus', tag: 'Campus Life' },
  { src: '/external/images/gallery/img2.jpeg', alt: 'School team gathered outdoors', tag: 'Student Moments' },
  { src: '/external/images/gallery/13.jpeg', alt: 'Ceremonial walk during a school event', tag: 'Events' },
  { src: '/external/images/gallery/img4.jpeg', alt: 'Students participating in a march', tag: 'Activities' },
  { src: '/external/images/gallery/img5.jpeg', alt: 'Traditional performance on the field', tag: 'Culture' },
  { src: '/external/images/gallery/img6.jpeg', alt: 'Outdoor school interaction', tag: 'Campus Life' },
  { src: '/external/images/gallery/img7.jpeg', alt: 'Flag activity during a school event', tag: 'Events' },
  { src: '/external/images/gallery/img8.jpeg', alt: 'Student group photo in uniform', tag: 'Student Moments' },
  { src: '/external/images/gallery/img9.jpeg', alt: 'School building exterior view', tag: 'Campus' },
  { src: '/external/images/gallery/img10.jpeg', alt: 'Another front view of the school building', tag: 'Campus' },
  { src: '/external/images/gallery/11.jpeg', alt: 'Students in a ceremonial procession', tag: 'Events' },
  { src: '/external/images/gallery/12.jpeg', alt: 'Guests and students during a school event', tag: 'Special Visit' },
  { src: '/external/images/gallery/14.jpeg', alt: 'Guests walking across the campus', tag: 'Special Visit' },
  { src: '/external/images/gallery/15.jpeg', alt: 'Students in coordinated activity', tag: 'Activities' },
  { src: '/external/images/gallery/16.jpeg', alt: 'Students performing during a celebration', tag: 'Culture' },
  { src: '/external/images/gallery/17.jpeg', alt: 'School event on the campus lawn', tag: 'Events' },
  { src: '/external/images/gallery/18.jpeg', alt: 'Parents and guests gathered outdoors', tag: 'Community' },
  { src: '/external/images/gallery/19.jpeg', alt: 'Students lined up during a formal event', tag: 'Discipline' },
  { src: '/external/images/gallery/20.jpeg', alt: 'Celebration with students and faculty', tag: 'Community' },
  { src: '/external/images/gallery/21.jpeg', alt: 'Stage moment from a school gathering', tag: 'Culture' },
  { src: '/external/images/gallery/22.jpeg', alt: 'Students participating in a school function', tag: 'Events' },
  { src: '/external/images/gallery/23.jpeg', alt: 'Guests and faculty engaging with students', tag: 'Special Visit' },
  { src: '/external/images/gallery/24.jpeg', alt: 'A lively school day on the ground', tag: 'Campus Life' },
  { src: '/external/images/gallery/25.jpeg', alt: 'Memorable group moment captured outdoors', tag: 'Student Moments' },
  { src: '/external/images/gallery/26.jpeg', alt: 'Ceremony with student participation', tag: 'Events' },
  { src: '/external/images/gallery/27.jpeg', alt: 'Students and teachers together on stage', tag: 'Community' },
  { src: '/external/images/gallery/28.jpeg', alt: 'Outdoor celebration with campus backdrop', tag: 'Campus Life' },
  { src: '/external/images/gallery/29.jpeg', alt: 'School event with audience and students', tag: 'Events' },
  { src: '/external/images/gallery/30.jpeg', alt: 'Students assembled for a special moment', tag: 'Discipline' },
  { src: '/external/images/gallery/31.jpeg', alt: 'Guests arriving on campus', tag: 'Special Visit' },
  { src: '/external/images/gallery/32.jpeg', alt: 'Student and faculty interaction outdoors', tag: 'Community' },
  { src: '/external/images/gallery/33.jpeg', alt: 'A bright school day near the building', tag: 'Campus' },
  { src: '/external/images/gallery/34.jpeg', alt: 'Gathering that highlights school culture', tag: 'Culture' },
  { src: '/external/images/gallery/35.jpeg', alt: 'Students during a festive activity', tag: 'Activities' },
  { src: '/external/images/gallery/36.jpeg', alt: 'Ceremonial school occasion', tag: 'Events' },
  { src: '/external/images/gallery/37.jpeg', alt: 'Shared moment among students and visitors', tag: 'Community' },
  { src: '/external/images/gallery/39.jpeg', alt: 'Students taking part in a formal walk', tag: 'Discipline' },
  { src: '/external/images/gallery/40.jpeg', alt: 'Open-air school function with participants', tag: 'Campus Life' },
  { src: '/external/images/gallery/41.jpeg', alt: 'A candid group photo from school life', tag: 'Student Moments' },
  { src: '/external/images/gallery/42.jpeg', alt: 'School function captured in action', tag: 'Events' },
  { src: '/external/images/gallery/44.jpeg', alt: 'Outdoor academic community gathering', tag: 'Community' },
  { src: '/external/images/gallery/45.jpeg', alt: 'Students featured in a campus event', tag: 'Activities' },
  { src: '/external/images/gallery/46.jpeg', alt: 'A celebration reflecting school spirit', tag: 'Culture' },
  { src: '/external/images/gallery/47.jpeg', alt: 'Another school event moment', tag: 'Events' },
  { src: '/external/images/gallery/48.jpeg', alt: 'Closing snapshot from school activities', tag: 'Campus Life' }
];

Modal.setAppElement('#root');

const Gallery = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const totalPages = Math.ceil(galleryImages.length / ITEMS_PER_PAGE);

  const currentPageImages = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, galleryImages.length);
    return galleryImages.slice(startIndex, endIndex);
  }, [currentPage]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const openModal = (absoluteIndex) => {
    setSelectedIndex(absoluteIndex);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const showPrevious = () => {
    setSelectedIndex((current) => (current === 0 ? galleryImages.length - 1 : current - 1));
  };

  const showNext = () => {
    setSelectedIndex((current) => (current === galleryImages.length - 1 ? 0 : current + 1));
  };

  const selectedImage = selectedIndex !== null ? galleryImages[selectedIndex] : null;

  return (
    <section className="gallery-page">
      <div className="gallery-hero">
        <div className="gallery-hero__copy">
          <span className="gallery-hero__eyebrow">Visual Story</span>
          <h1>Moments that make the campus feel alive.</h1>
          <p>
            A curated look at school life, celebrations, student participation, and the atmosphere
            families experience when they step inside Maxfort.
          </p>
        </div>

        <div className="gallery-hero__stats">
          <div className="gallery-stat">
            <FontAwesomeIcon icon={faImages} />
            <div>
              <strong>{galleryImages.length}+</strong>
              <span>captured moments</span>
            </div>
          </div>
          <div className="gallery-stat">
            <strong>Campus</strong>
            <span>events, visits, culture, and student life</span>
          </div>
        </div>
      </div>

      <div className="gallery-toolbar">
        <div className="gallery-toolbar__copy">
          <span>Page {currentPage}</span>
          <strong>Editorial gallery layout</strong>
        </div>
        <div className="gallery-toolbar__hint">Tap any frame to open the full image.</div>
      </div>

      <div className="gallery-grid">
        {currentPageImages.map((image, index) => {
          const absoluteIndex = (currentPage - 1) * ITEMS_PER_PAGE + index;
          const isFeatured = index === 0 || index === 5 || index === 8;

          return (
            <article
              className={`gallery-card ${isFeatured ? 'gallery-card--featured' : ''}`}
              key={image.src}
            >
              <button
                type="button"
                className="gallery-card__media"
                onClick={() => openModal(absoluteIndex)}
                aria-label={`Open ${image.alt}`}
              >
                <img src={image.src} alt={image.alt} />
                <span className="gallery-card__expand">
                  <FontAwesomeIcon icon={faExpand} />
                </span>
              </button>

              <div className="gallery-card__body">
                <span className="gallery-card__tag">{image.tag}</span>
                <h3>{image.alt}</h3>
                <p>Maxfort Education Gallery</p>
              </div>
            </article>
          );
        })}
      </div>

      <div className="pagination">
        <button
          type="button"
          className="pagination__arrow"
          onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
          disabled={currentPage === 1}
          aria-label="Previous gallery page"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        <div className="pagination__pages">
          {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
            <button
              key={pageNumber}
              type="button"
              className={`pagination__page ${currentPage === pageNumber ? 'is-active' : ''}`}
              onClick={() => setCurrentPage(pageNumber)}
            >
              {pageNumber}
            </button>
          ))}
        </div>

        <button
          type="button"
          className="pagination__arrow"
          onClick={() => setCurrentPage((page) => Math.min(page + 1, totalPages))}
          disabled={currentPage === totalPages}
          aria-label="Next gallery page"
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>

      <Modal
        isOpen={selectedImage !== null}
        onRequestClose={closeModal}
        className="gallery-modal"
        overlayClassName="gallery-overlay"
      >
        {selectedImage ? (
          <div className="gallery-modal__content">
            <button
              type="button"
              className="gallery-modal__close"
              onClick={closeModal}
              aria-label="Close image viewer"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>

            <div className="gallery-modal__image-wrap">
              <button
                type="button"
                className="gallery-modal__nav gallery-modal__nav--prev"
                onClick={showPrevious}
                aria-label="Previous image"
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>

              <img src={selectedImage.src} alt={selectedImage.alt} className="gallery-modal__image" />

              <button
                type="button"
                className="gallery-modal__nav gallery-modal__nav--next"
                onClick={showNext}
                aria-label="Next image"
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>

            <div className="gallery-modal__meta">
              <span>{selectedImage.tag}</span>
              <h3>{selectedImage.alt}</h3>
              <p>
                Image {selectedIndex + 1} of {galleryImages.length}
              </p>
            </div>
          </div>
        ) : null}
      </Modal>
    </section>
  );
};

export default Gallery;
